/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

import Notification from '../../notification';
import Tooltip from '../../tooltip';
import styles from './styles.css';

const { api, logError } = require('../../../../lib/bputils').default;
const { gTagEvent } = require('../../../../lib/global-site-tag').default;
const { canReplyReview } = require('../../../../lib/permissions').default;

const canReply = canReplyReview();

export default function StarReviewButton({ reviewId, starred: starredProps }) {
  const [starred, setStarred] = React.useState(starredProps);

  const handleOnStarClick = async () => {
    try {
      if (starred) {
        await api.delete({
          path: `/reviews/${reviewId}/star`,
        });
      } else {
        await api.post({
          path: `/reviews/${reviewId}/star`,
        });
      }
      gTagEvent('Reviews Card', `${!starred ? 'Starred' : 'Un-Starred'} A Review`);
      setStarred(!starred);
    } catch (err) {
      logError(err);
      Notification.error('There was an error while updating the review.');
    }
  };

  const getTooltipContent = () => (
    <>
      <div className={styles.headerText}>Star your best reviews</div>
      <div className={styles.secondaryText}>
        Your customer is satisfied with their experience and has left you with some kind words.
        Star these reviews so you can look back and share your best customer experiences!
        You can find this list by using the reviews search filters.
      </div>
    </>
  );

  return (
    <>
      { canReply ? (
        <>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <FontAwesomeIcon
            id={`starButton_${reviewId}`}
            icon={faStar}
            className={`${styles.star} ${starred ? styles.starred : ''}`}
            onClick={handleOnStarClick}
          />
          {
            !starred && (
              <Tooltip
                tootipContent={getTooltipContent()}
                uniqueTargetSelector={`starButton_${reviewId}`}
              />
            )
          }
        </>
      ) : null }
    </>
  );
}

StarReviewButton.propTypes = {
  reviewId: PropTypes.number.isRequired,
  starred: PropTypes.bool.isRequired,
};
